module.exports = __webpack_public_path__ + "static/img/Rectangle 10.c024e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 10.png
// module id = L5gw
// module chunks = 1